<template>
  <!-- 教师活跃趋势 -->
  <div class="teacher-activity-trend-container">
    <div class="title">
      <span></span>
      <span>教师活跃趋势</span>
    </div>
    <div class="container">
      <div style="width:100%;height: 100%" id="teacher-activity-trend-echarts-id"
           :style="{zoom:`${zoom}`,transformOrigin:'0 0'}"/>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  comments: {},
  computed: {},
  name: "teacher-activity-trend",
  props: {
    activityTrendList: {
      type: Array,
      default() {
        return [];
      }
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      //屏幕宽度
      screenWidth: 0,
      // 屏幕高度
      screenHeight: 0,
      // 新增属性，用于存储当前的 ECharts 实例
      echartsInstance: null,
    };
  },
  mounted() {
    //获取屏幕宽度
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // 获取屏幕高度
    this.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  },

  watch: {
    screenHeight: "initEcharts",
    activityTrendList(value) {
      if (value) {
        this.$nextTick(() => {
          this.initEcharts()
        })
      }
    }
  },
  methods: {
    /**
     * 加载折线图
     */
    initEcharts() {
      let option;
      let data = [];
      let date = []

      // 销毁旧的 ECharts 实例
      if (this.echartsInstance) {
        this.echartsInstance.dispose();
      }

      if (this.activityTrendList.length) {
        data = this.activityTrendList.map(item => item.userNum)
        date = this.activityTrendList.map(item => item.bizDate)
      }

      option = {
        grid: {
          top: 30,
          left: 70,
          right: 70,
          // containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255,255,255,0)', // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(255,255,255,1)', // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,255,255,0)', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              formatter: '{value}',
              fontSize: 16,
              margin: 20,
              textStyle: {
                color: '#C7D5F2',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#E0E2F7',
                opacity: 0.4
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#243753',
              },
            },
            axisTick: {
              show: false,
            },
            data: date,
          },
        ],
        yAxis: [
          {
            boundaryGap: false,
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#C7D5F2',
              },
              margin: 30
            },
            nameTextStyle: {
              color: '#C7D5F2',
              fontSize: 16,
              lineHeight: 40,
            },
            splitLine: {
              lineStyle: {
                color: '#E0E2F7',
                opacity: 0.4
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#283352',
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '教师数',
            type: 'line',
            smooth: true,
            showSymbol: true,
            symbol: 'circle',
            symbolSize: 10,
            // zlevel: 3,
            itemStyle: {
              normal: {
                // 拐点颜色
                color: '#06D6F8',
                // 拐点的描边颜色。[ default: '#000' ]
                borderColor: '#FFFFFF',
                // 拐点的描边宽度，默认不描边。[ default: 0 ]
                borderWidth: 3,
              },
              // shadowColor: 'rgba(0, 0, 0, .3)',
              // shadowBlur: 0,
              // shadowOffsetY: 2,
              // shadowOffsetX: 2,
            },
            lineStyle: {
              normal: {
                width: 4,
                color: '#06D6F8',
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'rgba(88,255,255,0.2)',
                      },
                      {
                        offset: 0.8,
                        color: 'rgba(88,255,255,0)',
                      },
                    ],
                    false
                ),
              },
            },
            data: data,
          },
        ],
      }

      this.echartsInstance = this.$echarts.init(
          document.getElementById("teacher-activity-trend-echarts-id")
      );

      this.echartsInstance.setOption(option);

      window.addEventListener("resize", () => {
        this.echartsInstance.resize();
      });
    },
  }
}

</script>

<style scoped lang="scss">
.teacher-activity-trend-container {
  position: relative;
  background-image: url("../../../assets/images/nanjingdataboard/bg-1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;

  .title {
    position: relative;
    width: 100%;
    top: 35px;
    height: 30px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
    text-align: left;
    //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

    span:nth-of-type(1) {
      display: inline-block;
      transform: translateY(2px);
      width: 8px;
      height: 18px;
      background: #06D6F8;
      border-radius: 4px;
      margin-left: 20px;
    }

    span:nth-of-type(2) {
      width: 120px;
      height: 20px;
      font-family: Microsoft YaHei;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .container {
    position: relative;
    top: 35px;
    width: 100%;
    height: calc(100% - 65px);
  }
}
</style>